module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-de-DE.1e5d666b.jpg";